<footer>

   <!-- <div class="footer-style-design">
         <p class="text-center w-100 mb-0">Copyright © {{currentYear}} UST All Rights Reserved, visit <a class=" cursor mx-1" href="https://www.ust.com/" target="_blank"><u>www.ust.com</u></a> to get in touch</p>
          <ul class="list-unstyled d-inline mb-0">
             <li class="d-inline px-2 border-right"><a target="_blank" routerLink="/terms-and-conditions">Terms and Conditions</a></li>
             <li class="d-inline px-2 border-right"><a target="_blank" routerLink="/policy">Privacy policy</a></li>
             <li class="d-inline px-2 txt cursor" (click)="sheduleDemo()"><u>Contact us</u></li> 
          </ul>
       </div> -->

       <ng-container *ngIf="tenantConfig === 'VOT'; else trlTemplate">
         <div
             class="cutsom-footer"
             [ngClass]="{
               'home-tagLine': service.getConfiguration('tenantGenericConfig')
                 ?.tenantTagLine
             }"
           >
             <div class="footer-style-design sticky-footer pb-20">
               <div>
                 <div class="footer-section-VOT">© {{ currentYear }} UST INC | ALL RIGHTS RESERVED</div>
               </div>
               <div class="d-flex justify-content-center flex-column text-center">
                 <span>
                   <span class="mr-2 footer-section1-VOT">POWERED BY</span
                   ><span class="footer-section2-link-VOT">UST iDEC</span>
                 </span>
               </div>
               <div class="d-flex justify-content-end">
                 <ul class="list-unstyled d-inline mb-0 interaction-disabled">
                   <li class="d-inline px-2 border-right footer-style-links">
                     <a
                       target="_blank"
                       routerLink="/terms-and-conditions"
                       class="footer-style-links-VOT"
                       >TERMS AND CONDITIONS</a
                     >
                   </li>
                   <li class="d-inline px-2 border-right">
                     <a target="_blank" routerLink="/policy" class="footer-style-links-VOT"
                       >PRIVACY POLICY</a
                     >
                   </li>
                   <li class="d-inline px-2 txt cursor" (click)="sheduleDemo()">
                     <u class="footer-style-links-VOT">CONTACT US</u>
                   </li>
                 </ul>
               </div>
             </div>
           </div>
       </ng-container>
       
 <ng-template #trlTemplate>
   <div class="footer-style-design" *ngIf="tenantConfig === 'TRL'; else commonFooter">
      <div>
         <div class="footer-section-TRL">© {{currentYear}} UST</div>
      </div>
      <div class="d-flex justify-content-center flex-column text-center">
         <span *ngIf="service.getConfiguration('tenantGenericConfig')?.tenantLogoFooter" class="prl-15">
            <img alt="logo" class="h-20"
               src="{{service.getConfiguration('tenantGenericConfig')?.tenantLogoFooter+token}}">
         </span>
         <span>
            <span class="mr-2 footer-section1">Powered by</span><span class="footer-section2-link">UST iDEC</span>
         </span>
      </div>
      <div class="d-flex justify-content-end">
         <a class=" cursor mx-1" href="https://www.ust.com/" target="_blank"><u
               class="footer-section2-link">www.ust.com</u></a>
      </div>
   </div>
   </ng-template>

   <ng-template #commonFooter>
      <div class="footer-style-design">
         <div>
            <div class="footer-section1">Copyright © {{currentYear}} UST All Rights Reserved,</div>
            <div class="footer-section1">visit <a class=" cursor mx-1" href="https://www.ust.com/" target="_blank"><u
                     class="footer-section2-link">www.ust.com</u></a> to get in touch</div>
         </div>
         <div class="d-flex justify-content-center flex-column text-center">
            <span *ngIf="service.getConfiguration('tenantGenericConfig')?.tenantLogoFooter" class="prl-15">
               <img alt="logo" class="h-20"
                  src="{{service.getConfiguration('tenantGenericConfig')?.tenantLogoFooter+token}}">
            </span>
            <span>
               <span class="mr-2 footer-section1">Powered by</span><span class="footer-section2-link">iDEC UST</span>
            </span>
         </div>
         <div class="d-flex justify-content-end">
            <ul class="list-unstyled d-inline mb-0 interaction-disabled">
               <li class="d-inline px-2 border-right footer-style-links"><a target="_blank"
                     routerLink="/terms-and-conditions" class="footer-style-links">Terms and Conditions</a></li>
               <li class="d-inline px-2 border-right"><a target="_blank" routerLink="/policy"
                     class="footer-style-links">Privacy policy</a></li>
               <li class="d-inline px-2 txt cursor" (click)="sheduleDemo()"><u class="footer-style-links">Contact us</u>
               </li>
            </ul>
         </div>
      </div>
   </ng-template>

</footer>